import { FormFieldTypes } from "../../../../data/formFieldType";

export const RequirementListingData = {
  name: "AdditionalInfo",
  initialState: {
    requirementName: "",
    channel: null,
    statusId: null,
  },
  formFields: [
    {
      id: "requirementName",
      lable: "Search By Requirement Name",
      Field_Name: "Search By Requirement Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "requirementName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-12 mb-3 pr-0 w-50-input",
      },
    },
    {
      id: "channel",
      lable: "Channel",
      Field_Name: "Channel",
      fieldType: FormFieldTypes.SELECT,
      dataField: "channel",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-3 mb-3",
      },
    },
    {
      id: "statusId",
      lable: "Status",
      Field_Name: "Status",
      fieldType: FormFieldTypes.SELECT,
      dataField: "statusId",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-3 mb-3",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
